// client/ui/StudentDocumentationManager.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class StudentDocumentationManager extends ComponentBase {
    constructor(config) {
        super(config);
        this.docManagerComponent = null;
        this.studentUserId = null; // Store the student's user ID
    }

    async initialize() {
        await super.initialize();
    }

    async initAfterLogin() {
        this.studentUserId = this.appClient.getSharedData('userId');

        if (!this.studentUserId) {
            this.log.error("StudentDocumentationManager: Cannot initialize DocumentManager without student's userId.");
            if (this.container) {
                this.container.innerHTML = `<p class="p-3 text-danger">${this.t('Error: User context not available for notes.')}</p>`;
                this.appClient.tx.applyTranslations(this.container);
            }
            return;
        }

        // The document workspace is scoped to the student's user ID and should not follow project selection.
        this.docManagerComponent = await this.createManagedComponent('DocumentWorkspaceManager', null, {
            instanceId: `${this.config.instanceId || 'studentNotes'}-docmanager`,
            contextId: this.studentUserId,    // Student's own user ID
            contextType: 'student-data',      // Specific type for student's personal documents
            ownerId: this.studentUserId,      // Student owns the instances created here
            syncProjectContext: false,
            provider: this.config.provider || 'kbmWorkspace'
        });

        if (this.container) {
            await this.render();
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'student-documentation-manager-container h-100';
        }
        this.container.innerHTML = '';

        if (this.docManagerComponent) {
            this.container.appendChild(await this.docManagerComponent.render());
        } else {
            const loadingMsg = document.createElement('div');
            loadingMsg.className = 'p-3 text-muted text-center';
            // Check if it's loading because userId isn't ready or because component creation is pending
            if (!this.studentUserId) {
                loadingMsg.textContent = this.t('Initializing student notes area...');
            } else {
                loadingMsg.textContent = this.t('Loading Student Notes...');
            }
            this.container.appendChild(loadingMsg);
        }
        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }

    destroy() {
        this.docManagerComponent?.destroy();
        this.docManagerComponent = null;
        super.destroy();
    }
}
